const camelcaseKeysDeep = require('camelcase-keys-deep');

export class Medication {
  key: string;
  name: string;
  active: boolean;
  description: string;
  rxCUI: string;
  lexiDrugSynId: string;
  lexiGenDrugId: string;

  constructor(data: any) {
    data = camelcaseKeysDeep(data);

    this.key = data.key;
    this.name = data.name;
    this.active = data.active;
    this.description = data.description;
    this.rxCUI = data.rxCUI;
    this.lexiDrugSynId = data.lexiDrugSynId;
    this.lexiGenDrugId = data.lexiGenDrugId;
  }
}



// WEBPACK FOOTER //
// ./src/app/medications/medication.ts